const AceHighwayManifestNoteLogApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/manifestNoteLog/get`,
    POST: `${process.env.REACT_APP_USER_ACE_HIGHWAY_URL}/ace-highway/manifestNoteLog/create`,
};

export default AceHighwayManifestNoteLogApiUrls
